const SEO_PAGE_TYPES = {
  ARTICLE: 'article',
  ARTICLES: 'articles',
  ARTICLES_CATEGORY: 'articles-category',
  CSU: 'csu',
  DEFAULT: 'default',
  FSU: 'fsu',
  LANDING: 'landing',
  PARTNER: 'partner',
  PERSON: 'person',
  PRESS_RELEASE: 'press_release',
  PRESS_RELEASES: 'press_releases',
  PRIZE: 'prize',
  PRIZES: 'prizes',
  SEARCH: 'search',
  404: '404'
};

export default SEO_PAGE_TYPES;
